import { render, staticRenderFns } from "./ContactCard.vue?vue&type=template&id=27b370f4&scoped=true"
import script from "./ContactCard.vue?vue&type=script&lang=ts"
export * from "./ContactCard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../imicsspa/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27b370f4",
  null
  
)

export default component.exports